







































































































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { institutionServer, patrolManagementServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import PatrolTaskAdd from './unit/task-add.vue';
import TaskInfo from './unit/task-info.vue';
import { arrayToTree } from '@/util/array';
import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';
const serverUrl = publishObjectPath.serverUrl;

@Component({
  components: { CollapseTransition, TreeUnit, PagingUnit, PatrolTaskAdd, TaskInfo },
  mixins: [TableStripe],
})
export default class PatrolTask extends Vue {
  private selectList: any = [];
  private deptData: any = [];

  /**
   * 【表格】表格选择变化
   */
  handleTableSelectionChange(val: any) {
    this.selectList = val;
  }

  tableLoading = false;

  private assignment = false;

  showFlag = 1;
  row: any = {
    id: '',
  };

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条

  private filterForm: any = {
    search: '',
    status: null,
    date: [],
    deptId: '',
  };
  formShow = false; // 是否显示表单搜索

  private statusList: any = [
    {
      label: '未完成',
      value: 0,
    },
    {
      label: '完成',
      value: 1,
    },
    {
      label: '未开始',
      value: 2,
    },
    {
      label: '待完成',
      value: 3,
    },
  ];

  // table数据
  tableData: any = [];
  private getDeptData() {
    institutionServer.getDeptAndSubDeptList({}).then((res: any) => {
      if (res.code === '200') {
        this.deptData = arrayToTree(res.data);
      }
    });
  }

  getSunStr(str: any) {
    if (str) {
      const a: any = str.indexOf('-');
      if (a !== -1) {
        return str.substr(a + 1);
      } else {
        return str;
      }
    } else {
      return '';
    }
  }

  /**
   *【按钮】添加按钮点击
   * @Params
   * @return
   **/
  handleAddBtnClick() {
    const PatrolTaskComponent: any = this.$refs['patrolTaskAdd'];
    PatrolTaskComponent.showAddDialog();
  }

  /**
   *【表格】表格详情按钮
   * @Params
   * @return
   **/
  handleTableDetailBtnClick(data: any) {
    this.showFlag = 2;
    this.row.id = data.id;
    // this.$router.push(`/schedule/patrol/patrol-receive-detail/${data.id}`);
  }

  /**
   * 【按钮】批量操作按钮指令
   */
  handleBatchCommand(command: string) {
    if (command === 'export') {
      this.handleBatchExport();
    } else {
      if (this.selectList.length === 0) {
        this.$message.warning('请选择您要操作的数据。');
        return;
      }
      if (command === 'remove') {
        this.handleBatchRemove();
      } else if (command === 'finish') {
        this.handleBatchFinish();
      }
    }
  }

  /**
   * 批量删除
   */
  handleBatchRemove() {
    this.$confirm('此操作将永久删除, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        const _selectList = this.selectList.map((item: any) => item.id);
        this.removeTaskData(_selectList);
      })
      .catch(() => {});
  }
  handleBatchExport() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    const _selectList = this.selectList.map((item: any) => item.id);
    let startDate: any = '';
    let endDate: any = '';
    if (this.filterForm.date !== null && this.filterForm.date.length > 0) {
      startDate = this.filterForm.date[0];
      endDate = this.filterForm.date[1];
    }
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: serverUrl + '/api/yunnan/patrol/task/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        deptId: this.filterForm.deptId ? this.filterForm.deptId : null,
        search: this.filterForm.search ? this.filterForm.search : null,
        startTime: startDate ? startDate : null,
        endTime: endDate ? endDate : null,
        status: this.filterForm.status,
        paging: true,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        ids: _selectList,
      },
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }

  /**
   *【表格】表格删除按钮
   * @Params
   * @return
   **/
  handleTableDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then((ctx: any) => {
        this.removeTaskData(data.id);
      })
      .catch((e: any) => {});
  }
  /**
   * 【接口】删除巡检任务
   * @param ids {String} 用户id
   */
  async removeTaskData(ids: string | string[]) {
    try {
      const res: any = await patrolManagementServe.deletePatrolTask(ids);
      if (res.code === '204') {
        this.$message.success('删除成功。');
      } else {
        this.$message.warning('删除失败。');
      }
      this.getAllData();
    } catch (e) {
      this.$message.warning('删除失败。');
      throw new Error();
    }
  }

  /**
   *【岗位编辑窗口】巡检任务配置编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleEditResponse() {
    this.getAllData();
  }

  handleInfoResponse() {
    this.showFlag = 1;
    this.getAllData();
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getAllData();
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取所有数据
    this.getDeptData();
    this.getAllData();
  }
  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    let startDate: any = '';
    let endDate: any = '';
    if (this.filterForm.date !== null && this.filterForm.date.length > 0) {
      startDate = this.filterForm.date[0];
      endDate = this.filterForm.date[1];
    }
    this.tableLoading = true;
    // 获取所有数据
    patrolManagementServe
      .getPatrolTaskListData({
        deptId: this.filterForm.deptId ? this.filterForm.deptId : null,
        search: this.filterForm.search ? this.filterForm.search : null,
        startTime: startDate ? startDate : null,
        endTime: endDate ? endDate : null,
        status: this.filterForm.status,
        paging: true,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.tableLoading = false;
        this.$message.error('查询失败,请稍后重试!');
      });
  }

  handleAssignmentDetailBtn(data: any) {
    // this.$router.push({name: 'AssignmentEvaluationEdit',query: {type:'edit',id: data.taskRiskAssessId,version: data.taskRiskAssessVersion}});
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    // 获取到符合搜索条件的数据
    (this.queryDataForm as any).pageNo = 1;
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    this.filterForm = {
      search: '',
      status: null,
      date: [],
    };
    // 获取全部数据
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   * @param1 暂无
   * @returns 暂无
   */
  setFormShow() {
    this.formShow = !this.formShow;
  }

  handleBatchFinish() {
    this.$prompt('请填写检修完成的原因', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputType: 'textarea',
    })
      .then((value: any) => {
        // console.log(value, value.value);
        if (!value.value) {
          this.$message({
            type: 'warning',
            message: '请填写检修完成的原因！',
          });
        } else {
          const _selectList = this.selectList.map((item: any) => item.id);
          this.finishTaskData(_selectList, value.value);
        }
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      });
  }

  /**
   * 【接口】删除巡检任务
   * @param ids {String} 用户id
   */
  async finishTaskData(ids: string | string[], value: any) {
    try {
      const res: any = await patrolManagementServe.finishPatrolTask({
        finishWay: '检修完成',
        reason: value,
        taskIdList: ids,
      });
      if (res.code === '200') {
        this.$message.success('任务检修完成成功。');
      } else {
        this.$message.warning('任务检修完成失败。');
      }
      this.getAllData();
    } catch (e) {
      this.$message.warning('任务检修完成失败。');
      throw new Error();
    }
  }
}
